import useAccount from '@hooks/useAccount'
import useClientConfig from 'config/clients/useClientConfig'
import dayjs from 'dayjs'
import _ from 'lodash'

/**
 * Parse the filters names and formats.
 * @param {Object} filters
 * @returns {Object}
 */
export default (filters: FiltersUI, extras?: any): Filters => {
  const { getDashboardCustomFilters } = useClientConfig()

  //console.log('Parsing filters')
  //console.log(filters)

  const customDashboardFilters = getDashboardCustomFilters()
  const selectedCriticalMoments = filters.criticalMoments?.[0] ?? undefined

  if (customDashboardFilters[selectedCriticalMoments] !== undefined) {
    //console.log('retornando custom dashbord filters con valores')
    return customDashboardFilters[selectedCriticalMoments]
  }

  //console.log('retornando custom dashbord filters vacios')
  return {}
}
